<template>
    <div class="mobile-tabs">
        <van-tabs v-model="active" class="tabs" swipeable>
            <van-tab v-for="(item, index) in tabList" :key="index" :title="item.name" :name="item.type">
                <div class="mobile-tabs__container">
                    <slot></slot>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
export default {
    name: 'MobileTabs',
    props: {
        activeName: {
            type: String,
            default: ''
        },
        tabList: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        active: {
            set(newV) {
                if (newV !== this.active) {
                    this.$router.replace({ path: this.$route.path, query: { tab: newV } });
                    this.changeActive({ name: newV });
                }
            },
            get() {
                return this.activeName;
            }
        }
    },
    watch: {
        '$route.query': {
            handler(newVal) {
                const { tab } = newVal;
                if (tab !== undefined && tab !== '') this.active = tab;
            },
            immediate: true
        }
    },
    methods: {
        changeActive(tab) {
            this.$emit('change', tab.name);
        }
    }
};
</script>

<style lang="scss" scoped>
.mobile-tabs {
    width: 100vw;
    height: 48px;
    background: #2d2d2d;
    ::v-deep {
        .van-tabs__nav {
            display: flex;
            justify-content: space-between;
            border-bottom: none;
            background: #2d2d2d;
        }
        .van-tabs--line .van-tabs__wrap {
            height: 48px;
        }
        .van-tab {
            line-height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.6);
            margin-bottom: 13px;
        }
        .van-tab--active {
            color: white;
            font-size: 16px;
            font-weight: 600;
        }
    }
    ::v-deep .van-tabs__line {
        width: 50px;
        background-color: #2d2d2d;
        &::before,
        &::after {
            content: '';
            position: absolute;
            right: 0;
            bottom: 0;
            height: 4px;
            width: 50%;
        }

        &::before {
            left: 0;
            background: #00b2f8;
        }

        &::after {
            right: 0;
            background: #047aff;
        }
    }
}
</style>
